import { useLocation } from "react-router";

/**
 * Custom hook to check if a link is currently active
 * @param to - The link path to check
 * @param isHashLinks - Whether to include hash in the location comparison
 * @returns Boolean indicating if the link is active
 */
export default function useIsActiveLink(
  to: string,
  isHashLinks?: boolean,
): boolean {
  const location = useLocation();

  const currentLocation = isHashLinks
    ? location.pathname + location.hash
    : location.pathname;

  return to === currentLocation;
}
